(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["furlabs-ugc"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-furlabs-ugc]');
    if (!roots.length) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const setPaused = (root, paused) => {
      root.classList.toggle('is-paused', paused);
      const button = root.querySelector('[data-ugc-toggle]');
      const videos = root.querySelectorAll('video');
      if (button) {
        button.setAttribute('aria-pressed', paused ? 'true' : 'false');
        button.textContent = paused ? button.dataset.playLabel || 'Play' : button.dataset.pauseLabel || 'Pause';
      }
      videos.forEach((video) => {
        if (paused || reduce) {
          video.pause();
        } else {
          video.play().catch(() => {});
        }
      });
    };

    const fillTrack = (root) => {
      const scroller = root.querySelector('.furlabs-ugc__scroller');
      const track = root.querySelector('[data-ugc-track]');
      if (!scroller || !track || track.dataset.filled === 'true') return;

      const seed = [...track.children];
      if (!seed.length) return;

      while (track.scrollWidth < scroller.clientWidth * 1.25) {
        seed.forEach((card) => track.appendChild(card.cloneNode(true)));
      }

      const clone = track.cloneNode(true);
      clone.removeAttribute('data-ugc-track');
      clone.setAttribute('aria-hidden', 'true');
      scroller.appendChild(clone);
      track.dataset.filled = 'true';
    };

    roots.forEach((root) => {
      fillTrack(root);

      const button = root.querySelector('[data-ugc-toggle]');
      if (button) {
        button.dataset.pauseLabel = button.textContent.trim();
        button.dataset.playLabel = 'Play';
        button.addEventListener('click', () => {
          setPaused(root, !root.classList.contains('is-paused'));
        });
      }

      const io = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) {
            root.querySelectorAll('video').forEach((video) => video.pause());
            return;
          }
          if (!root.classList.contains('is-paused') && !reduce) {
            root.querySelectorAll('video').forEach((video) => video.play().catch(() => {}));
          }
        },
        { threshold: 0.15 }
      );
      io.observe(root);

      if (reduce) setPaused(root, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
